'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp2;

var _templateObject = _taggedTemplateLiteralLoose(['\n      subscription project{\n        project{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription project{\n        project{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n      subscription projectMember{\n        projectMember{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription projectMember{\n        projectMember{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n      subscription team{\n        team{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription team{\n        team{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n      subscription teamMember{\n        teamMember{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription teamMember{\n        teamMember{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n      subscription position{\n        position{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription position{\n        position{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n      subscription task{\n        task{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription task{\n        task{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n      subscription taskReaction{\n        taskReaction{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription taskReaction{\n        taskReaction{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n      subscription service{\n        service{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription service{\n        service{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n      subscription timer{\n        timer{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    '], ['\n      subscription timer{\n        timer{\n          mutation\n          node{\n            id\n          }\n        }\n      }\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _context13 = require('@prisma-cms/context');

var _context14 = _interopRequireDefault(_context13);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SubscriptionProvider = (_temp2 = _class = function (_Component) {
  _inherits(SubscriptionProvider, _Component);

  function SubscriptionProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, SubscriptionProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      subscriptions: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  SubscriptionProvider.prototype.componentDidMount = function componentDidMount() {
    this.subscribe();
  };

  SubscriptionProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribe();
  };

  SubscriptionProvider.prototype.subscribe = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee10() {
      var _this2 = this;

      var client, subscriptions, subscribeProject, projectSub, subscribeProjectMember, projectMemberSub, subscribeTeam, teamSub, subscribeTeamMember, teamMemberSub, subscribePosition, positionSub, subscribeTask, taskSub, subscribeTaskReaction, taskReactionSub, subscribeService, serviceSub, subscribeTimer, timerSub;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              client = this.context.client;

              if (client) {
                _context10.next = 4;
                break;
              }

              console.error("client is empty");
              return _context10.abrupt('return');

            case 4:
              _context10.next = 6;
              return this.unsubscribe();

            case 6:
              subscriptions = this.state.subscriptions;
              subscribeProject = (0, _graphqlTag2.default)(_templateObject);
              _context10.next = 10;
              return client.subscribe({
                query: subscribeProject,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee(data) {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function next(_x) {
                    return _ref2.apply(this, arguments);
                  };
                }(),
                error: function error(_error) {
                  console.error('subscribeCalls callback with error: ', _error);
                }
              });

            case 10:
              projectSub = _context10.sent;
              subscriptions.push(projectSub);
              subscribeProjectMember = (0, _graphqlTag2.default)(_templateObject2);
              _context10.next = 15;
              return client.subscribe({
                query: subscribeProjectMember,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee2(data) {
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function next(_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }(),
                error: function error(_error2) {
                  console.error('subscribeCalls callback with error: ', _error2);
                }
              });

            case 15:
              projectMemberSub = _context10.sent;
              subscriptions.push(projectMemberSub);
              subscribeTeam = (0, _graphqlTag2.default)(_templateObject3);
              _context10.next = 20;
              return client.subscribe({
                query: subscribeTeam,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee3(data) {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function next(_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }(),
                error: function error(_error3) {
                  console.error('subscribeCalls callback with error: ', _error3);
                }
              });

            case 20:
              teamSub = _context10.sent;
              subscriptions.push(teamSub);
              subscribeTeamMember = (0, _graphqlTag2.default)(_templateObject4);
              _context10.next = 25;
              return client.subscribe({
                query: subscribeTeamMember,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee4(data) {
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this2);
                  }));

                  return function next(_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }(),
                error: function error(_error4) {
                  console.error('subscribeCalls callback with error: ', _error4);
                }
              });

            case 25:
              teamMemberSub = _context10.sent;
              subscriptions.push(teamMemberSub);
              subscribePosition = (0, _graphqlTag2.default)(_templateObject5);
              _context10.next = 30;
              return client.subscribe({
                query: subscribePosition,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref6 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee5(data) {
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this2);
                  }));

                  return function next(_x5) {
                    return _ref6.apply(this, arguments);
                  };
                }(),
                error: function error(_error5) {
                  console.error('subscribeCalls callback with error: ', _error5);
                }
              });

            case 30:
              positionSub = _context10.sent;
              subscriptions.push(positionSub);
              subscribeTask = (0, _graphqlTag2.default)(_templateObject6);
              _context10.next = 35;
              return client.subscribe({
                query: subscribeTask,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref7 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee6(data) {
                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this2);
                  }));

                  return function next(_x6) {
                    return _ref7.apply(this, arguments);
                  };
                }(),
                error: function error(_error6) {
                  console.error('subscribeCalls callback with error: ', _error6);
                }
              });

            case 35:
              taskSub = _context10.sent;
              subscriptions.push(taskSub);
              subscribeTaskReaction = (0, _graphqlTag2.default)(_templateObject7);
              _context10.next = 40;
              return client.subscribe({
                query: subscribeTaskReaction,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref8 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee7(data) {
                    return _regenerator2.default.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this2);
                  }));

                  return function next(_x7) {
                    return _ref8.apply(this, arguments);
                  };
                }(),
                error: function error(_error7) {
                  console.error('subscribeCalls callback with error: ', _error7);
                }
              });

            case 40:
              taskReactionSub = _context10.sent;
              subscriptions.push(taskReactionSub);
              subscribeService = (0, _graphqlTag2.default)(_templateObject8);
              _context10.next = 45;
              return client.subscribe({
                query: subscribeService,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref9 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee8(data) {
                    return _regenerator2.default.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this2);
                  }));

                  return function next(_x8) {
                    return _ref9.apply(this, arguments);
                  };
                }(),
                error: function error(_error8) {
                  console.error('subscribeCalls callback with error: ', _error8);
                }
              });

            case 45:
              serviceSub = _context10.sent;
              subscriptions.push(serviceSub);
              subscribeTimer = (0, _graphqlTag2.default)(_templateObject9);
              _context10.next = 50;
              return client.subscribe({
                query: subscribeTimer,
                variables: {}
              }).subscribe({
                next: function () {
                  var _ref10 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator2.default.mark(function _callee9(data) {
                    return _regenerator2.default.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _this2.reloadData();

                          case 1:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this2);
                  }));

                  return function next(_x9) {
                    return _ref10.apply(this, arguments);
                  };
                }(),
                error: function error(_error9) {
                  console.error('subscribeCalls callback with error: ', _error9);
                }
              });

            case 50:
              timerSub = _context10.sent;
              subscriptions.push(timerSub);
              this.setState({
                subscriptions: subscriptions
              });

            case 53:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function subscribe() {
      return _ref.apply(this, arguments);
    }

    return subscribe;
  }();

  SubscriptionProvider.prototype.unsubscribe = function unsubscribe() {
    var _this3 = this;

    return new Promise(function (resolve) {
      var subscriptions = _this3.state.subscriptions;

      if (subscriptions && subscriptions.length) {
        subscriptions.map(function (n) {
          n.unsubscribe();
        });
        Object.assign(_this3.state, {
          subscriptions: []
        });
      }

      resolve();
    });
  };

  SubscriptionProvider.prototype.reloadData = function () {
    var _ref11 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee11() {
      var _context11, client, loadApiData;

      return _regenerator2.default.wrap(function _callee11$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context11 = this.context, client = _context11.client, loadApiData = _context11.loadApiData;
              _context12.next = 3;
              return loadApiData();

            case 3:
              _context12.next = 5;
              return client.reFetchObservableQueries();

            case 5:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee11, this);
    }));

    function reloadData() {
      return _ref11.apply(this, arguments);
    }

    return reloadData;
  }();

  SubscriptionProvider.prototype.render = function render() {
    var children = this.props.children;
    return children; // return children ? <children.type
    //   {...children.props}
    //   {...other}
    // /> : null;
  };

  return SubscriptionProvider;
}(_react.Component), _class.contextType = _context14.default, _temp2);
exports.default = SubscriptionProvider;
module.exports = exports['default'];